package com.flowyride.core.domain.usecase

import com.flowyride.core.domain.gpx.GpxDocument
import com.flowyride.core.domain.gpx.GpxWaypoint
import com.flowyride.core.domain.gpx.GpxWriter
import com.flowyride.core.domain.model.Place
import com.flowyride.core.domain.model.Route

class BuildGpxUseCase(private val writer: GpxWriter) {

    /** @param stops The places the route goes through, in riding order (at least departure and arrival). */
    operator fun invoke(route: Route, stops: List<Place>): GpxDocument {
        require(stops.size >= 2) { "A GPX needs at least a departure and an arrival" }
        val title = stops.joinToString(" → ") { it.name }
        val slug = listOf("flowyride", stops.first().name.slugify(), stops.last().name.slugify())
            .filter { it.isNotEmpty() }
            .joinToString("-")
        return GpxDocument(
            fileName = "$slug.${GpxDocument.EXTENSION}",
            content = writer.write(route, title, stops.map { GpxWaypoint(it.name, it.point) }),
        )
    }
}

private val ACCENTS = mapOf(
    'à' to 'a', 'â' to 'a', 'ä' to 'a', 'á' to 'a', 'ã' to 'a',
    'ç' to 'c',
    'é' to 'e', 'è' to 'e', 'ê' to 'e', 'ë' to 'e',
    'î' to 'i', 'ï' to 'i', 'í' to 'i',
    'ô' to 'o', 'ö' to 'o', 'ó' to 'o', 'õ' to 'o',
    'ù' to 'u', 'û' to 'u', 'ü' to 'u', 'ú' to 'u',
    'ÿ' to 'y', 'ñ' to 'n',
)

internal fun String.slugify(): String =
    lowercase()
        .map { ACCENTS[it] ?: it }
        .joinToString("") { if (it in 'a'..'z' || it in '0'..'9') it.toString() else "-" }
        .replace(Regex("-+"), "-")
        .trim('-')
